import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    series: []
  },
  mutations: {
    SET_SERIES(state, series) {
      state.series = Object.freeze(series);
    }
  },
  actions: {
    setSeries(context, series) {
      context.commit("SET_SERIES", series);
    }
  },
  getters: {
    photos: state => {
      const photos = state.series.map(series => series.photos);
      return _.flatten(photos);
    },
    photoIds: (state, getters) => {
      return getters.photos.map(photo => photo.id);
    },
    getPhotoById: state => id => {
      const photos = state.series.map(series => series.photos);
      const flatten = _.flatten(photos);
      return flatten.find(photo => photo.id === id);
    },
    getSeriesByPhotoId: state => id => {
      for (let i = 0, len = state.series.length; i < len; i++) {
        const find = state.series[i].photos.filter(
          photo => photo.id === _.toString(id)
        );
        if (find.length > 0)
          return { id: find[0].id, slug: state.series[i].artist.slug };
      }

      return null;
    },
    getSeriesByArtistSlug: state => slug => {
      return state.series.find(series => series.artist.slug === slug);
    },
    maxId: (state, getters) => {
      return Math.max.apply(Math, getters.photoIds);
    },
    minId: (state, getters) => {
      return Math.min.apply(Math, getters.photoIds);
    },
    randomId: (state, getters) => {
      const item =
        getters.photoIds[Math.floor(Math.random() * getters.photoIds.length)];

      return parseInt(item);
    }
  },
  modules: {}
});
